import React from 'react';
import PropTypes from 'prop-types';
import theme from 'theme';

const Text = ({
  children, size, style, className, weight, title, color, link, ...props
}) => {
  let addedClass = '';
  let addedColor = '';

  if (title) {
    addedClass = `font-title font-bold text-base md:text-xl ${className}`;
  } else {
    addedClass = `${size} ${weight} ${className}`;
  }

  if (link) {
    addedClass += ' cursor-pointer';
    addedColor = theme.colors['green-primary'];
  } else {
    addedColor = color;
  }

  return (
    <p
      onClick={link || null}
      role={link ? 'presentation' : null}
      className={`${addedClass}`}
      style={{
        color: addedColor,
        ...style,
      }}
      {...props}
    >
      {children}
    </p>
  );
};

Text.propTypes = {
  // children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.node]).isRequired,
  size: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  className: PropTypes.string,
  weight: PropTypes.string,
  title: PropTypes.bool,
  link: PropTypes.func,
  color: PropTypes.string,
};

Text.defaultProps = {
  size: '',
  style: {},
  className: '',
  weight: '',
  title: false,
  color: '',
  link: null,
};

export default Text;
